import i18n from 'i18next';
import * as yup from 'yup';

const validationsUsername = yup.object().shape({
  username: yup.string().required(() => i18n.t('security-login.validations.usernameRequired'))
});
export default validationsUsername;
